import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useProjectStatus } from "../../actions/statusActions";
import textWeight from "../../utils/textWeight";

export default () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const { TextWeight } = textWeight();
  const dispatch = useDispatch();
  const {
    data: projectData,
    isLoading,
    isError,
    error,
  } = useProjectStatus(currentPage);
  useEffect(() => {
    const newTotalItems = projectData?.data?.pagination?.totalItems;
    if (newTotalItems && newTotalItems !== totalItems) {
      setTotalItems(newTotalItems);
    }
    if (projectData?.data?.data.length === 0 && currentPage > 1) {
      setCurrentPage(1);
    }
  }, [projectData, totalItems, currentPage]);

  const handleProjectClick = (val) => {
    const normalizedStatus = val?.quantityReportStatus?.trim()?.toLowerCase();
    if (normalizedStatus === "completed") {
      navigate(`/project-details/${val?._id}`);
      dispatch({
        type: "UPDATE_PROJECT_ID",
        payload: { projectID: val?._id },
      });
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  const itemsPerPage = 6;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  return {
    isLoading,
    projectData,
    handleProjectClick,
    totalItems,
    currentPage,
    totalPages,
    handlePageChange,
    TextWeight,
  };
};
